<template>
  <v-dialog
    v-model="show"
    max-width="500px"
    scrollable
    persistent
  >
    <v-card :loading="formProcessing">
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="command"
                  required
                  label="Command"
                  :error-messages="commandErrors"
                  @input="v$.command.$touch()"
                  @blur="v$.command.$touch()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="schedule"
                  required
                  label="Schedule"
                  :error-messages="scheduleErrors"
                  @input="v$.schedule.$touch()"
                  @blur="v$.schedule.$touch()"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="close()"
        >
          Cancel
        </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    editedItem: {
      type: Object,
      default() {
        return {
          id: null,
          command: '',
          schedule: '',
        };
      },
    },
  },
  setup() { return { v$: useVuelidate() }; },
  validations: {
    command: {
      required,
    },
    schedule: {
      required,
    },
  },
  data() {
    return {
      valid: false,
      id: null,
      command: '',
      schedule: '',
      formProcessing: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    formTitle() {
      const newOrUpdate = this.isNewItem ? 'New' : 'Update';
      return `${newOrUpdate} Cronjob`;
    },
    isNewItem() {
      return !this.editedItem.id;
    },
    commandErrors() {
      const errors = [];

      if (!this.v$.command.$dirty) {
        return errors;
      }

      if (this.v$.command.required.$invalid) {
        errors.push('Cronjob command is required.');
      }

      return errors;
    },
    scheduleErrors() {
      const errors = [];

      if (!this.v$.schedule.$dirty) {
        return errors;
      }

      if (this.v$.schedule.required.$invalid) {
        errors.push('Cronjob schedule is required.');
      }

      return errors;
    },
  },
  watch: {
    editedItem() {
      this.id = this.editedItem.id;
      this.command = this.editedItem.command;
      this.schedule = this.editedItem.schedule;
      this.active = this.editedItem.active;
    },
  },
  methods: {
    ...mapActions('notification', ['setNotification']),

    save() {
      this.v$.$touch();

      if (!this.v$.$invalid) {
        this.formProcessing = true;
        let request = '';
        const data = { command: this.command, schedule: this.schedule, active: this.active ?? 0 };

        if (this.isNewItem) {
          request = this.$axios.post('/api/v1/cronjob', data);
        } else {
          request = this.$axios.put(`/api/v1/cronjob/${this.editedItem.id}`, data);
        }

        request
          .then((res) => {
            this.$emit('item-saved');

            this.setNotification({
              message: `${res.data.command} has been saved.`,
              color: 'green',
            });
          })
          .catch(() => {
            this.setNotification({
              message: 'There was an error processing your request.',
              color: 'red',
            });
          })
          .then(() => {
            this.formProcessing = false;

            this.close();
          });
      }
    },
    close() {
      this.v$.$reset();

      this.$emit('close-modal');

      this.command = '';
    },
  },
};
</script>

<style></style>
